// Scope legacy workshop controls to the learning surface. Artifact colors stay intact.
export const learnWebPalette = {
  page: 'var(--learn-bg)', panel: 'var(--learn-surface)', cardSolid: 'var(--learn-surface)',
  ink: 'var(--learn-ink)', inkSoft: 'var(--learn-muted)', muted: 'var(--learn-muted)',
  accent: 'var(--learn-ink)', accentFill: 'var(--learn-ink)', onAccent: 'var(--learn-bg)',
  rule: 'var(--learn-border)', ruleStrong: 'var(--learn-control)',
};
